import {getAppSessionCookieHeader} from "../appCookie";
import api from "../../Api";

export const squarePay = async (client, cart) => {
  let endpoint = client?.guid ? 'square/pay/' + client.guid : 'square/pay/kiosk';
  const resp = await api.post(endpoint + getAppSessionCookieHeader(), cart).then((response) => {
    return response;
  });
  return resp;
}

export const squareSave = async (client, cart) => {
  const resp = await api.post('square/save/' + client.guid  + getAppSessionCookieHeader(), cart).then((response) => {
    return response;
  });
  return resp;
}

function handleError(error) {
  let err = {
    error: true,
    message: error?.response?.data?.message || JSON.stringify(error)
  }
  return err;
}
